<template>
  <div
    class="card card-body mb-2 d-block"
  >
    <div v-if="isMedia(researchItem.item.render_type)">
      <v-youtube
        v-if="researchItem.item.is_video"
        :video-id="researchItem.item.youtube_id"
        player-width="100%"
        player-height="200px"
      />

      <v-audio
        v-else-if="researchItem.item.is_audio"
        :source="item.media_file"
      />
    </div>
    <div v-else>
      <div>
        <h5 v-html="formattedItemText(researchItem.title)" />
        <component
          :is="ITEM_COMPONENTS[researchItem.item.render_type]"
          :research-item="computedResearchItem"
          :as-answer="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  isMedia,
  isMultiChoice,
  isSingleChoice,
  formattedItemText,
} from '@/common/services/items';
import { YouTubePlayer } from 'vue-youtube-embed';
import Audio from '@/common/components/Audio.vue';
import { ITEM_COMPONENTS } from '@/reviewer/constants';

export default {
  name: 'ItemAnswer',
  components: {
    'v-audio': Audio,
    'v-youtube': YouTubePlayer,
  },
  props: {
    researchItem: {
      type: Object,
      required: true,
    },
    organisationName: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
    answerValue: {
      // Type not specified: can be string, number or array;
      required: false,
    },
  },
  methods: {
    isMultiChoice,
    isSingleChoice,
    isMedia,
    formattedItemText,
  },
  data() {
    return {
      ITEM_COMPONENTS,
    };
  },
  computed: {
    computedResearchItem() {
      return {
        ...this.researchItem,
        answer: { value: this.answerValue },
      };
    },
  },
};
</script>
